import {
    ButtonContainer,
    Eyebrow,
    ImgContainer,
    ImgWrap,
    NewBody,
    NewContainer,
    NewText,
    NewTitle,
} from "./styled"

export const New = ({props}: any) => {

    const cleanedText = (props.description || "").replace(/https?:\/\/\S+/g, '').trim();

    return <NewContainer>
        <ImgWrap>
            <ImgContainer src={props.image} alt={props.title || "Новость"} loading="lazy"/>
        </ImgWrap>
        <NewBody>
            <Eyebrow>Новость</Eyebrow>
            {props.title && <NewTitle>{props.title}</NewTitle>}
            {cleanedText && <NewText>{cleanedText}</NewText>}
            <ButtonContainer>
                Подробнее
                <svg viewBox="0 0 14 10" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M1 5h12M9 1l4 4-4 4" stroke="currentColor" strokeWidth="1.6"
                          strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                </svg>
            </ButtonContainer>
        </NewBody>
    </NewContainer>
}
